import React from 'react';
import { Box, Typography, Paper, Container, Divider } from '@mui/material';

const PrivacyPolicy = ({ isDialog }) => {
    return (
        <Container
            maxWidth={isDialog ? false : "lg"}
            disableGutters={isDialog}
            sx={isDialog ? {} : { mt: 4, mb: 4 }}
        >
            <Paper elevation={isDialog ? 0 : 3} sx={isDialog ? {} : { p: 4, borderRadius: 2 }}>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d', mb: 3 }}>
                    Privacy Policy
                </Typography>

                <Typography variant="body2" sx={{ mb: 2, color: '#555' }}>
                    ShipperDock Loadboard Platform <br />
                    Owned and operated by Goodlanes Transportation Services LLC
                </Typography>

                <Typography variant="body2" sx={{ mb: 3, color: '#555' }}>
                    Goodlanes Transportation Services LLC acts as the data controller for personal and business
                    information collected through the ShipperDock platform.
                </Typography>

                <Divider sx={{ mb: 3 }} />

                <Box sx={{ color: '#333' }}>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        1. Information We Collect
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 2 }}>
                        We may collect personal and business information including your name, email address,
                        phone number, company details, DOT or MC numbers, login credentials (encrypted),
                        IP address, device and browser information, usage activity, and subscription or
                        billing status.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        DOT and MC numbers are collected solely for verification, identification, and trust
                        purposes within the Platform.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        2. Legal Basis for Processing
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        We process personal information based on your consent, the performance of a contract,
                        compliance with legal obligations, and our legitimate business interests such as fraud
                        prevention, security, and service improvement.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        3. How We Use Your Information
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        Information is used to operate and maintain the Platform, verify users, manage
                        subscriptions and billing, communicate service-related notices, improve functionality,
                        and prevent fraud or misuse.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        4. Data Sharing and Disclosure
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        We do not sell personal information. We may share information with trusted service
                        providers such as payment processors, hosting providers, analytics services, or legal
                        authorities when required by law. All third parties are required to protect your
                        information.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        5. User Responsibility
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        You are responsible for the accuracy of the information you provide and for any data
                        you choose to share with other users through the Platform, whether publicly or privately.
                        This includes any personal or business information shared directly with other users
                        through listings, messages, or contact details provided on the Platform.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        6. Cookies and Tracking Technologies
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        We may use cookies and similar technologies to enable essential functionality,
                        analyze usage, and improve user experience. You may control cookies through your
                        browser settings.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        7. Data Retention
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        We retain personal information only for as long as necessary to fulfill operational
                        purposes, legal obligations, dispute resolution, and enforcement of our agreements.
                        Information associated with closed, deactivated, or inactive accounts may be retained
                        for a limited period as required for legal compliance, dispute resolution, fraud
                        prevention, and enforcement of our agreements.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        8. Data Security
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        We implement commercially reasonable administrative, technical, and organizational
                        safeguards to protect information. However, no system is completely secure, and use
                        of the Platform is at your own risk.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        9. International Data Transfers
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        Your information may be stored or processed in countries outside your own. Such
                        transfers occur only as necessary to operate the Platform and are conducted in
                        accordance with applicable data protection laws.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        10. Children’s Privacy
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        The Platform is intended for business use by commercial entities and professionals
                        in the freight and logistics industry. It is not intended for individuals under the
                        age of 18. We do not knowingly collect personal information from minors.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        11. Your Rights
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        Depending on your jurisdiction, you may have the right to access, correct, delete,
                        or restrict the processing of your personal data, or withdraw consent where applicable.
                        Requests can be made by contacting us.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        12. Third-Party Links
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        The Platform may contain links to third-party websites or services. We are not
                        responsible for their privacy practices or content.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        13. Policy Updates
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        We may update this Privacy Policy from time to time. Continued use of the Platform
                        constitutes acceptance of the updated policy.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        14. Contact Information
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ mb: 2 }}>
                        For privacy-related inquiries, please contact us at:
                        <br />
                        <strong>support@shipperdock.com</strong>
                    </Typography>

                    <Typography variant="body2" paragraph sx={{ mb: 3 }}>
                        This Privacy Policy is governed by applicable laws of the United States.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="body2" align="center" sx={{ color: '#777' }}>
                        © 2025 Goodlanes Transportation Services LLC. All Rights Reserved.
                    </Typography>

                </Box>
            </Paper>
        </Container>
    );
};

export default PrivacyPolicy;
